import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove Emergent badge if present
const removeEmergentBadge = () => {
  const badge = document.getElementById('emergent-badge');
  if (badge) badge.remove();
  
  // Also check for any dynamically injected badges
  document.querySelectorAll('a[href*="emergent"]').forEach(el => el.remove());
  document.querySelectorAll('[id*="emergent"]').forEach(el => el.remove());
};

// Run on load and observe for dynamic additions
removeEmergentBadge();
const observer = new MutationObserver(removeEmergentBadge);
observer.observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
